"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrudClient = void 0;
const tslib_1 = require("tslib");
const should_cache_decorator_1 = require("../cache-support/should-cache.decorator");
const should_reset_cache_decorator_1 = require("../cache-support/should-reset-cache.decorator");
const array_models_1 = require("../models/array.models");
const authenticated_client_1 = require("./authenticated.client");
class CrudClient extends authenticated_client_1.AuthenticatedClient {
    constructor() {
        super(...arguments);
        this.version = 'v1';
    }
    getAll(projectId, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, null, { fields });
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    search(parameters) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(parameters.projectId, null, parameters);
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getById(projectId, id, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, id, { fields });
            const response = yield this.httpGet(url, { returnNullOn404: true, throwOnError: true });
            return response.payload;
        });
    }
    update(entity) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = entity.projectId;
            const id = entity.id;
            if (!projectId || !id) {
                throw new Error('Project ID and entity ID are required.');
            }
            const url = this.getPath(projectId, id);
            const payload = this.getUpdatePayloadModel(Object.assign(Object.assign({}, entity), { creatorId: undefined, id: undefined, projectId: undefined }), 'put');
            const response = yield this.httpPut(url, payload);
            return response.payload;
        });
    }
    create(entity) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const projectId = entity.projectId;
            if (!projectId) {
                throw new Error('Project ID are required.');
            }
            const url = this.getPath(projectId);
            const payload = this.getUpdatePayloadModel(Object.assign(Object.assign({}, entity), { updaterId: undefined, projectId: undefined }), 'post');
            const response = yield this.httpPost(url, payload);
            return response.payload;
        });
    }
    delete(projectId, id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = this.getPath(projectId, id);
            yield this.httpDelete(url);
        });
    }
    getPath(projectId, path, parameters) {
        let result = `/${this.version}/projects/${projectId}/${this.entityPath}`;
        path = (path && path.toString());
        if (path && path[0] === '/') {
            result += path;
        }
        else if (path) {
            result += `/${path}`;
        }
        if (parameters) {
            result += `?${this.getQueryString(parameters)}`;
        }
        return result;
    }
    getUpdatePayloadModel(entity, _) {
        return entity;
    }
}
tslib_1.__decorate([
    should_cache_decorator_1.ShouldCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, array_models_1.FieldArray]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "getAll", null);
tslib_1.__decorate([
    should_cache_decorator_1.ShouldCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "search", null);
tslib_1.__decorate([
    should_cache_decorator_1.ShouldCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "getById", null);
tslib_1.__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "update", null);
tslib_1.__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "create", null);
tslib_1.__decorate([
    should_reset_cache_decorator_1.ShouldResetCache,
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Number]),
    tslib_1.__metadata("design:returntype", Promise)
], CrudClient.prototype, "delete", null);
exports.CrudClient = CrudClient;
//# sourceMappingURL=crud.client.js.map